import LastScale from './LastScale';

export default LastScale;
